import React, { Component, useRef, useCallback } from 'react';
import moment from 'moment';
import {
    format, startOfMonth, endOfMonth, differenceInCalendarDays, addDays, getMonth, getYear,
    endOfToday, startOfToday, isBefore, isAfter, isSameDay, isMonday, isTuesday, isWednesday, isThursday,
    isFriday, isSaturday, isSunday
} from 'date-fns';
import commonFunction from '../../../../lib/utils/common';
// import styles from "./calendar.module.css";

const MonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

class MobileCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFormat: !commonFunction.isValueEmpty(this.props.dateFormat) ? this.props.dateFormat : "dd/MM/yyyy",
            isCalendarVisible: false,
            numberOfClicks: 0,
            twoCalendarsArray: [],
            isDoubleSelection: !commonFunction.isValueEmpty(this.props.doubleSelection) ? this.props.doubleSelection : false,
            dateLimitArr: this.props.startDateLimit,
            currentMonths: [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: startOfMonth(startOfToday()),
            selectedMonthEndDate: endOfMonth(startOfMonth(new Date())),
            endDate: this.props.endDate,
            hoverEndDate: this.props.endDate,
            totalDays: "",
            pageX: "",
            pageY: "",
            initPageX: "",
            initPageY: "",
            totalMonths: !commonFunction.isValueEmpty(this.props.totalMonths) ? this.props.totalMonths : 12,
            serviceType: this.props.serviceType ? this.props.serviceType : ""
        };
        this.debouncedOnClickDateCell = this.debounce(this.onClickDateCell,1);
    }

    componentDidMount() {
        this.setState({
            currentMonths: this.props.type === "double" ? !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))),
                getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))) + 1] :
                [getMonth(startOfMonth(new Date())), getMonth(startOfMonth(new Date())) + 1] : !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))))] :
                [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: !commonFunction.isValueEmpty(this.state.dateLimitArr) ? startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))) : startOfMonth(startOfToday()),
        })
    }
    componentDidUpdate() {
        if (this.props.endDate !== this.state.endDate) {
            this.setState({ endDate: this.props.endDate });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = () => {
        if (this.state.isCalendarVisible === true) this.setState({ isCalendarVisible: false });
    };

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    specDateEle(date, type) {
        try {
            let toDefaultFormat = moment(date, this.state.dateFormat);
            let getDate = toDefaultFormat.format(this.state.dateFormat);
            let getYear = typeof date === 'string' ? new Date(getDate).getFullYear() : date.getFullYear();
            let getMonth = typeof date === 'string' ? new Date(getDate).getMonth() : date.getMonth();
            let getDay = typeof date === 'string' ? new Date(getDate).getDate() : date.getDate();
            switch (type) {
                case 'y':
                    return getYear;
                case 'm':
                    return getMonth;
                case 'd':
                    return getDay;
                case 'a':
                    return [getYear, getMonth, getDay];
                default:
                    return null;
            }
        } catch (err) {
            console.log('Error in specDateEle:', err);
            return null;
        }
    }

    onClickChangeVisibility = () => {
        this.props.changeVisibility(!this.props.isVisible);
    }

    onClickDateCell = (day, month, year, bool) => {
        if (!bool) {
            if (this.state.isDoubleSelection === true) {
                let date = new Date(year, month, day);
                if (this.state.numberOfClicks === 0) {
                    this.setState({ numberOfClicks: 1, totalDays: '' }, () => {
                        this.props.onChangeDate(date, 'startDate');
                        this.props.onChangeDate('', 'endDate');
                    });
                } else if (this.state.numberOfClicks === 1) {
                    let differenceInDays = differenceInCalendarDays(new Date(date), new Date(this.props.startDate));
                    if (differenceInDays < 0) {
                        this.setState({ numberOfClicks: 0 }, () => {
                            this.props.onChangeDate(date, 'startDate');
                            this.props.onChangeDate('', 'endDate');
                        });
                    } else {
                        this.setState({ numberOfClicks: 0 }, () => {
                            this.props.onChangeDate(date, 'endDate');
                        });
                    }
                }
            } else {
                let date = moment(new Date(year, month, day)).format(this.state.dateFormat);
                this.props.onChangeDate(date);
            }
        }
    }

    renderCalendar = () => {
        let temp = this.state.selectedMonthStartDate;
        let twoCalendarsArray = [];
        for (let i = 0; i < this.state.totalMonths; i++) {
            let StartDateOfMonth = temp;
            let monthHead = addDays(StartDateOfMonth, i === 0 ? 0 : 1);
            let endDateOfMonth = endOfMonth(monthHead);
            let dayDifference = differenceInCalendarDays(endDateOfMonth, monthHead);
            let days = [];
            let month = getMonth(monthHead);
            let year = getYear(monthHead);
            let startOfMonthDay = isMonday(monthHead)
            ? 0
            : isTuesday(monthHead)
            ? 1
            : isWednesday(monthHead)
            ? 2
            : isThursday(monthHead)
            ? 3
            : isFriday(monthHead)
            ? 4
            : isSaturday(monthHead)
            ? 5
            : 6;
            let startDateLimit = this.props.startDateLimit;
            let isHoliday = this.props.isHoliday ? this.props.isHoliday : false;
            let holidayStartDate = this.props.holidayStartDate ? this.props.holidayStartDate : '';
            let holidayEndDate = this.props.holidayEndDate ? this.props.holidayEndDate : '';
            let startDate = this.props.startDate;
            let endDate = this.state.endDate;
            let hoverDate = this.state.hoverEndDate;

            for (let k = 0; k < startOfMonthDay; k++) {
                days.push({ day: "", month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
            }
            for (let j = 0; j <= dayDifference; j++) {
                let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(startDateLimit, 'y'), this.specDateEle(startDateLimit, 'm'), this.specDateEle(startDateLimit, 'd')));
                let disableDate = false;

                if (isHoliday) {
                    let isHLDBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(holidayStartDate, 'y'), this.specDateEle(holidayStartDate, 'm'), this.specDateEle(holidayStartDate, 'd')));
                    let isHLDAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(holidayEndDate, 'y'), this.specDateEle(holidayEndDate, 'm'), this.specDateEle(holidayEndDate, 'd')));
                    disableDate = isHLDBeforeDate || isHLDAfterDate;
                }

                let isAfterThirtyNights = isAfter(
                    new Date(year, month, j + 1),
                    addDays(new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")), 30)
                );

                if (isBeforeDate || disableDate || (isAfterThirtyNights && this.state.numberOfClicks !== 0)) {
                    days.push({ day: j + 1, month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
                } else {
                    let isStartDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")));
                    let isEndDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, "y"), this.specDateEle(endDate, "m"), this.specDateEle(endDate, "d")));
                    let isHoverDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(hoverDate, "y"), this.specDateEle(hoverDate, "m"), this.specDateEle(hoverDate, "d")));
                    days.push({ day: j + 1, month: month, year: year, isDisable: false, selectedDate: isStartDate || isEndDate, highlight: isHoverDate });
                }

                if (this.state.isDoubleSelection === true) {
                    let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                    let isAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));

                    if (isAfterDate && isBeforeDate) {
                        days[j].highlight = true;
                    }
                }
            }

            if (this.state.isDoubleSelection === true) {
                let startDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')).toString());
                let endDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')).toString());
                if (startDateIndex !== -1) {
                    days[startDateIndex].selectedDate = true;
                }
                if (endDateIndex !== -1) {
                    days[endDateIndex].selectedDate = true;
                }
            } else {
                let SelectedDate = this.props.value;
                let selectedDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(SelectedDate, 'y'), this.specDateEle(SelectedDate, 'm'), this.specDateEle(SelectedDate, 'd')).toString())
                if (selectedDateIndex !== -1) {
                    days[selectedDateIndex].selectedDate = true;
                }
            }
            temp = endDateOfMonth;
            twoCalendarsArray.push(
                <div className={this.props.styles.calendar_whole_body} key={i}>
                    <div className={this.props.styles.calendar_head}>
                        <div className={this.props.styles.calendar_head_center_side}>
                            <h3>{format(monthHead, 'MMMM yyyy')}</h3>
                        </div>
                    </div>
                    <div className={this.props.styles.calendar_body}>
                        <div className={this.props.styles.calendar_week_heads}>
                            {weekList.map((ele, ix) => (
                                <div className={this.props.styles.coln_center_week} key={i + "th_month_" + ix + "week"}>
                                    {ele}
                                </div>
                            ))}
                        </div>
                        <div className={this.props.styles.calendar_day_list}>
                            {days.map((ele, idx) => {
                                let isHighLight = false;
                                let isHoverDate = false;
                                if (this.state.isDoubleSelection === true) {
                                    let isBeforeDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    let isBeforeEndDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                                    let isAfterDate = isAfter(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));
                                    isHoverDate = isSameDay(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    if ((isAfterDate && isBeforeDate && commonFunction.isValueEmpty(endDate)) || (isAfterDate && isBeforeEndDate && (!commonFunction.isValueEmpty(endDate)))) {
                                        isHighLight = true;
                                    }
                                }
                                return (
                                    <div className={(ele.selectedDate === true && ele.day) ? this.props.styles.day_cell_center + ' ' + this.props.styles.selected_calendar_date : isHighLight === true && ele.day !== "" ? this.props.styles.day_cell_center_highlight : this.props.styles.day_cell_center} key={i + '_' + idx}
                                        onClick={(e) => { e.stopPropagation(); this.debouncedOnClickDateCell(ele.day, ele.month, ele.year, ele.isDisable) }} onMouseEnter={(e) => this.onHoverDayCell(ele, e)} >
                                        {this.state.isDoubleSelection === true && !commonFunction.isValueEmpty(ele.day) && ele.isDisable === false && !commonFunction.isValueEmpty(hoverDate) && isHoverDate && !commonFunction.isValueEmpty(this.state.totalDays) && <div className={this.props.styles.container_tooltip}>{this.state.totalDays} Night</div>}
                                        <span className={ele.isDisable === true ? this.props.styles.calendar_day_disable : ''}>{ele.day}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
        }
        return twoCalendarsArray;
    }

    onClickDoneBtn = () => {
        this.props.changeVisibility(false);
    }

    onHoverDayCell = (currentDate, e) => {
        let date = moment(new Date(currentDate.year, currentDate.month, currentDate.day)).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
        this.setState({
            hoverEndDate: date
        });
        if (!commonFunction.isValueEmpty(this.props.startDate) && commonFunction.isValueEmpty(this.state.endDate)) {
            this.setState({
                hoverEndDate: date, pageX: Number(e.clientX) - Number(this.state.initPageX), pageY: Number(e.clientY) - Number(this.state.initPageY)
            }, () => {
                let difference = differenceInCalendarDays(new Date(currentDate.year, currentDate.month, currentDate.day), new Date(this.props.startDate));
                if (difference > 0) this.setState({ totalDays: difference });
                else this.setState({ totalDays: '' });
            })
        }
    }

    selectDateLabelType() {
        let dateLabel = { calaHeadTitle1: "DEPARTURE DATE", calaHeadTitle2: "RETURN DATE" };
        if (this.state.serviceType === "hotel") {
            dateLabel.calaHeadTitle1 = "Check In";
            dateLabel.calaHeadTitle2 = "Check Out";
        } else if (this.state.serviceType === "holiday") {
            dateLabel.calaHeadTitle1 = "START DATE";
            dateLabel.calaHeadTitle2 = "END DATE";
        }
        return dateLabel;
    }

    render() {
        return (
            <div onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} className={this.props.styles.calendar_wid_container}>
                {this.props.value === '' && <label>{this.props.label}</label>}
                <label>Check In & Check Out</label>
                <div className={this.props.styles.calendar_wid_main}>
                    {!commonFunction.isValueEmpty(this.props.iconImage) ? (
                        <>
                            <svg width="19" height="19"><path fillRule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.85V3.148c0 .162-.49-.224-.892-.303a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.589.627.966V16.656c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627-.248-.25-.401-.303-.401-.968V3.148c0-.377.153-.718.401-.966.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.303v3.499zm16.922.94H.938v9.068c0 .117.049.224.702.303-.498.402-.391.892-.272.892h15.288c.118 0 .225-.49.304-.892.42-.077.9-.184.9-.303V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"></path></svg>
                        </>
                    ) : null}
                    {this.state.isDoubleSelection === true ? (
                        <>
                        {
                            this.props.theme === 'theme2' ?
                            <div className={this.props.styles.new_cal_main} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                                <div className={this.props.styles.flex_cont_cal}>
                                <div className={this.props.styles.new_cal_digit}>
                                    <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[0] : ''}</h1>
                                </div>
                                <div className={this.props.styles.new_cal_text}>
                                    <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[1] : ''}</p>
                                    <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[2] : ''}</p>
                                </div>
                                </div>

                                <div className={this.props.styles.flex_cont_cal}>
                                <div className={this.props.styles.new_cal_digit}>
                                    <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[3] : ''}</h1>
                                </div>
                                <div className={this.props.styles.new_cal_text}>
                                    <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[4] : ''}</p>
                                    <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[5] : ''}</p>
                                </div>
                                </div>
                            </div>

                            :

                            <input type='text' autoComplete={'off'} id="hotels_check_in_out_input" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? this.props.value : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                        }

                </>
                    ) : (
                        <>
                    {
                        this.props.theme === 'theme2' ?
                            <div className={this.props.styles.new_cal_main} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                                <div className={this.props.styles.flex_cont_cal}>
                                <div className={this.props.styles.new_cal_digit}>
                                    <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[0] : ''}</h1>
                                </div>
                                <div className={this.props.styles.new_cal_text}>
                                    <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[1] : ''}</p>
                                    <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[2] : ''}</p>
                                </div>
                                </div>

                                <div className={this.props.styles.flex_cont_cal}>
                                <div className={this.props.styles.new_cal_digit}>
                                    <h1 className={this.props.styles.new_cal_digit_text}>{this.props.value ? this.props.value.split('-')[3] : ''}</h1>
                                </div>
                                <div className={this.props.styles.new_cal_text}>
                                    <p className={this.props.styles.new_cal_month}>{this.props.value ? this.props.value.split('-')[4] : ''}</p>
                                    <p className={this.props.styles.new_cal_year}>{this.props.value ? this.props.value.split('-')[5] : ''}</p>
                                </div>
                                </div>
                            </div>
                            :
                            <input type='text' autoComplete={'off'} id="hotels_check_in_out_input" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? this.props.value : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                        }

                        </>
                    )}
                </div>
                {this.props.isVisible === true ? (
                    <div className={this.props.styles.calendar_wid_container_popup}>
                        <div className={this.props.styles.calendar_modal_close} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div className={this.props.styles.calendar_head_container}>
                            <div className={this.props.styles.calendar_head_main}>
                                <div className={this.props.styles.calendar_head_com + " " + this.props.styles.calendar_head_left}>
                                    <span className={this.props.styles.calendar_head_title}>{this.selectDateLabelType().calaHeadTitle1}</span>
                                    <h5>{!commonFunction.isValueEmpty(this.props.startDate) ? format(new Date(this.props.startDate), 'dd MMMM yyyy') : 'Select from date'}</h5>
                                </div>
                                <div className={this.props.styles.calendar_head_com + " " + this.props.styles.calendar_head_right}>
                                    <span className={this.props.styles.calendar_head_title}>{this.selectDateLabelType().calaHeadTitle2}</span>
                                    <h5>{!commonFunction.isValueEmpty(this.props.endDate) ? format(new Date(this.props.endDate), 'dd MMMM yyyy') : 'Select to date'}</h5>
                                </div>
                            </div>
                        </div>
                        <div className={this.props.styles.calendar_main_body_popup}>
                            {this.renderCalendar()}
                        </div>
                        <div className={this.props.styles.calendar_footer}>
                            <button onClick={(e) => { e.stopPropagation(); this.onClickDoneBtn() }}>Done</button>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }
}

export default MobileCalendar;
